import { ExceptionCode } from "../../../common/src/enums";

export default function useError() {
  const messagesMap: Record<string, string> = {
    [ExceptionCode.OTARunningOrInterrupted]: "Contains SIM with OTA running or interrupted",
    [ExceptionCode.AppletAlreadyInstalled]: "Some SIMs already have the applet installed",
    [ExceptionCode.ClientCertificateDelivered]: "Please delete the client certificate from the SIM",
    [ExceptionCode.CsrExists]: "Please delete the CSR from the SIM",
    [ExceptionCode.PublicKeyExists]: "Please delete the public key from the SIM",
    [ExceptionCode.FileExists]: "Please delete the file from the SIM",
    [ExceptionCode.DuplicateIpAddress]: "Duplicate IP address",
  };
  const codeToMessage = (code: string | undefined) => {
    if (!code) {
      return;
    }
    return messagesMap[code];
  };

  return { codeToMessage };
}
